import { FC } from 'react';
import { TrashIcon } from 'icons/trash';
import { useDispatch } from 'react-redux';
import { IdName } from 'types/common-types';
import { AccessLevel, Permission } from 'services/permission.model';
import { PermissionGuardActions } from 'modules/permission-guard/permission-guard.controller';
import DropdownMenu, { DropdownMenuItem } from 'components/dropdown-menu/dropdown-menu';
// import { DuplicateIcon } from 'icons/duplicate';
import { useTranslation } from 'react-i18next';
import { CopyIcon } from 'icons/copy';

type Props = {
  itemId: string;
  buttonClassName?: string;
  taskDepartments: IdName[];
  isProcessingGuard: boolean;
  isTaskFromRootHierarchy?: string | null;
  isRootAdditionalTask?: boolean;
  copyAdditionalTaskLink: (taskId: string) => void;
  // duplicateAdditionalTask: (taskId: string) => void;
  openDeleteConfirmationModal: (taskId: string) => void;
};

const ActionsMenu: FC<Props> = ({
  itemId,
  isTaskFromRootHierarchy,
  taskDepartments,
  buttonClassName = '',
  isProcessingGuard,
  isRootAdditionalTask = false,
  copyAdditionalTaskLink,
  // duplicateAdditionalTask,
  openDeleteConfirmationModal,
}) => {
  const { t } = useTranslation();
  const dispatch = useDispatch();

  const handleOnDeleteClick = () => {
    const accessLevels = [AccessLevel.userDepartment, AccessLevel.userDepartmentSubDepartments, AccessLevel.allDepartments];
    if (
      !dispatch(PermissionGuardActions.checkPermissionAndShowModal(Permission.webTaskEditLevel, accessLevels, taskDepartments))
    ) {
      return;
    }

    if (isProcessingGuard) {
      dispatch(PermissionGuardActions.openModal(isProcessingGuard));

      return;
    }
    openDeleteConfirmationModal(itemId);
  };

  const shouldShowDelete = !(isRootAdditionalTask || isTaskFromRootHierarchy);

  const menuItems: Record<any, Array<DropdownMenuItem>> = {
    additionalTasks: [
      // {
      //   onClick: () => duplicateAdditionalTask(itemId),
      //   key: 'action_duplicate_task',
      //   text: t('additional_tasks.action_menu.duplicate'),
      //   icon: <DuplicateIcon width={16} height={16} />,
      // },
      {
        onClick: () => copyAdditionalTaskLink(itemId),
        key: 'action_copy_link',
        text: t('additional_tasks.action_menu.copy_link'),
        icon: <CopyIcon width={16} height={16} />,
      },
      shouldShowDelete && {
        onClick: () => handleOnDeleteClick(),
        key: 'action_delete_task',
        text: t('global.action_delete'),
        icon: <TrashIcon width={16} height={16} />,
      },
    ].filter(Boolean) as DropdownMenuItem[],
    '': [],
  };

  return <DropdownMenu buttonClassName={buttonClassName} id="collapse-content-card" items={menuItems.additionalTasks} />;
};

export default ActionsMenu;
